import React from 'react';
import { useLinesContext } from '../../contexts/Lines';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTooltip } from '../BuildingBlocks/Tooltip/Tooltip';
import { steps as editActiveLineSteps } from '../lines/requestChange/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import TelegramIcon from '@material-ui/icons/Telegram';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing(0.5),
  },
}));

export default function LineActionsEditing({ line, handleLineSubmit }) {
  const classes = useStyles();
  const { editLineCancel, editActiveLineStep } = useLinesContext();

  const actions = [
    {
      name: 'Save',
      icon: line.editActiveLine ? TelegramIcon : CheckCircleIcon,
      onClick: async () => {
        await handleLineSubmit(line);
      },
    },
    {
      name: 'Cancel',
      icon: CancelIcon,
      onClick: () => {
        if (line.editActiveLine) {
          editActiveLineStep(editActiveLineSteps.cancel);
        } else {
          editLineCancel(line.id);
        }
      },
    },
  ];

  return (
    <div className={classes.root}>
      {!line.editLeftSide &&
        actions.map((action) => {
          const Icon = action.icon;
          return (
            <CustomTooltip
              key={action.name}
              arrow
              title={action.name}
              placement="top"
            >
              <IconButton size="small" onClick={action.onClick}>
                <Icon />
              </IconButton>
            </CustomTooltip>
          );
        })}
    </div>
  );
}
